<template>
  <div class="report">
    <div>
      <!-- v-if  v-show="webview" -->
      <!-- <webview class="print-div" :src="printHtmlUrl" ref="wviewPrint" @did-finish-load="createPDF"></webview>   @did-frame-finish-load="createPDF"-->
      <webview
        class="print-div"
        :src="printHtmlUrl"
        ref="wviewPrint"
        @did-finish-load="createPDF()"
      ></webview>
    </div>
  </div>
</template>

<script>
import CalcReportDate from "../../../dryeye/js/reportDataHanld";
import fileSys from "../../../fileoprators/fileSystem";
import Drawcanvas from "../../../dryeye/js/drawReportCanvas";
import moment from "moment";
import { formatDate } from "../../../shared/filters";
import { getSystemTime } from "../../../shared/utils";
import { mapGetters } from "vuex";
let path = window.require("path");
const ejs = window.require("ejs");

let reportDataHandle = new CalcReportDate();

function adjustPageIsExist(objOne, objTwo, sex, callback) {
  let needhiddenFuns = {}; // 需要整个隐藏的功能
  let needshowFuns = []; // 记录需要显示的功能
  let recordOneKey = Object.keys(objOne);
  let recordTwoKey = Object.keys(objTwo);
  for (let k = 0; k < recordOneKey.length; k++) {
    for (let x = 0; x < recordTwoKey.length; x++) {
      if (recordOneKey[k] === recordTwoKey[x]) {
        if (
          objOne[`${recordOneKey[k]}`].exist === false &&
          objTwo[`${recordTwoKey[k]}`].exist === false
        ) {
          needhiddenFuns[`${recordOneKey[k]}`] = false;
        } else if (objOne[`${recordOneKey[k]}`].exist === true) {
          needshowFuns.push(`${recordOneKey[k]}`);
        } else if (objTwo[`${recordTwoKey[k]}`].exist === true) {
          needshowFuns.push(`${recordTwoKey[k]}`);
        }
      }
    }
  }
  callback(needhiddenFuns, needshowFuns);
}

export default {
  props: ["currentPatient", "recordOneInfo", "recordTwoInfo", "exportFilesPath", "startShowReport"],
  name: "report",
  data() {
    return {
      webview: false,
      printHtmlUrl_brother: "",
      printHtmlUrl: "",
      // 是否有 OS OD
      whichRecordSelected: [],
      recordOd: [],
      carambolaImg: [],
      setPrintItemSize: {
        A5: [120, 120, 320],
        A6: [120, 120, 180],
        B5: [120, 120, 320],
        A4: [120, 120, 320],
        USLetter: [120, 120, 320]
      },
      printItemSize: {
        A5: [120, 320, 12, 100, 96],
        A6: [120, 120, 10, 70, 288],
        B5: [120, 400, 14, 160, 96],
        A4: [120, 500, 16, 180, 64],
        USLetter: [150, 500, 16, 200, 64]
      },
      pdfSize: {
        A4: "A4",
        A5: "A5",
        A6: "A6",
        B5: "B5",
        USLetter: "USLetter"
      },
      selReportMode: "oldReport",
      printBaseInfo: {
        sex: "",
        imgs: [],
        age: "",
        name: "",
        id: "",
        printdate: "",
        checkdoctor: "",
        checkresult: "",
        CheckdateOne: "",
        CheckdateTwo: ""
      },
      debugPath: {
        isdebug: true,
        utils: "../../utils/"
      },
      mediviewSettingCfg: {},
      needPagination: false
    };
  },
  methods: {
    createPDF() {
      let _this = this;

      const replace = this.recordOneInfo
        ? this.recordOneInfo && this.recordOneInfo.data.date.replace(/\s+/g, "_")
        : this.recordTwoInfo && this.recordTwoInfo.data.date.replace(/\s+/g, "_");
      const replace2 = replace.replace(/[\s:]/g, "-");
      if (_this.printHtmlUrl) {
        // if ((this.recordOneInfo.diagnosed && !this.recordTwoInfo) && (this.recordOneInfo)) {
        if (_this.recordOneInfo && _this.recordOneInfo.data.type === "OS" && !_this.recordTwoInfo) {
          _this.$refs.wviewPrint.getWebContents().printToPDF(
            {
              pageSize: "A4"
            },
            (error, data) => {
              if (error) throw error;
              const path = _this.exportFilesPath.osPath + replace2 + ".pdf";
              fileSys.writeFile(path, data, (error) => {
                if (error) {
                  throw error;
                } else {
                  _this.webview = false;
                  _this.$emit("exportFinished", true);
                  _this.printHtmlUrl = "";
                  console.timeEnd("reporttime");
                }
              });
            }
          );
        } else if (
          this.recordOneInfo &&
          this.recordOneInfo.data.type === "OD" &&
          !this.recordOneInfo
        ) {
          _this.$refs.wviewPrint.getWebContents().printToPDF(
            {
              pageSize: "A4"
            },
            (error, data) => {
              if (error) throw error;
              const path = _this.exportFilesPath.odPath + replace2 + ".pdf";
              fileSys.writeFile(path, data, (error) => {
                if (error) {
                  throw error;
                } else {
                  _this.webview = false;
                  _this.$emit("exportFinished", true);
                  _this.printHtmlUrl = "";
                  console.timeEnd("reporttime");
                }
              });
            }
          );
        } else if (
          this.recordOneInfo &&
          this.recordTwoInfo &&
          this.recordOneInfo.diagnosed &&
          this.recordTwoInfo.diagnosed
        ) {
          _this.$refs.wviewPrint.getWebContents().printToPDF(
            {
              pageSize: "A4"
            },
            (error, data) => {
              if (error) {
                console.log("error3--", error);
              } else {
                const path = _this.exportFilesPath.osPath + replace2 + ".pdf";
                fileSys.writeFile(path, data, (error) => {
                  if (error) {
                    throw error;
                  } else {
                    _this.$refs.wviewPrint.getWebContents().printToPDF(
                      {
                        pageSize: "A4"
                      },
                      (error, data2) => {
                        if (error) {
                          console.log(error);
                        } else {
                          const path = _this.exportFilesPath.odPath + replace2 + ".pdf";
                          fileSys.writeFile(path, data2, (error) => {
                            if (error) {
                              console.log("error3--2", error);
                            } else {
                              _this.webview = false;
                              _this.printHtmlUrl = "";
                              console.timeEnd("reporttime");
                              _this.$emit("exportFinished", true);
                            }
                          });
                        }
                      }
                    );
                  }
                });
              }
            }
          );
        }
      } else {
        _this.$emit("exportFinished", true);
      }
    },
    start() {
      if (!this.selectedVersion) {
        this.selReportMode = "oldReport";
      } else if (Number(this.selectedVersion) === 1 && window.settings.language === "zh_CN") {
        this.selReportMode = "oldReport";
      } else if (Number(this.selectedVersion) === 2 && window.settings.language === "zh_CN") {
        this.selReportMode = "newReport";
      } else if (window.settings.language !== "zh_CN") {
        this.selReportMode = "oldReport";
      }
      this.mediviewSettingCfg = window.printSettings;
      this.recordOneData = reportDataHandle.dataHandle(this.recordOneInfo, this.selReportMode);
      this.recordTwoData = reportDataHandle.dataHandle(this.recordTwoInfo, this.selReportMode);
    },
    drawCarambola: function (recordInfo) {
      // 绘制能力值图
      let centerx = 200; // 中心点X坐标
      let centery = 80; // 中心点Y坐标
      let size = 60; // 背景图大小
      let scores = [];
      let funsIsExist = [];
      for (let id in recordInfo) {
        if (
          recordInfo[id].score !== undefined &&
          recordInfo[id].score !== "" &&
          (recordInfo[id].Levelup === undefined || !recordInfo[id].Levelup)
        ) {
          if (recordInfo[id].score) {
            // 解决雷达图眼红填充色
            scores.push(recordInfo[id].score);
          }
        }
        if (
          recordInfo[id].exist !== undefined &&
          recordInfo[id].exist !== "" &&
          (recordInfo[id].Levelup === undefined || !recordInfo[id].Levelup)
        ) {
          funsIsExist.push(recordInfo[id].exist);
        }
      }
      let lang = this.$i18n.messages[this.$i18n.locale].langcfg;

      let myCanvas = new Drawcanvas(lang, { height: 150, width: 445, size: true }, "white");
      myCanvas.drawBackGround(centerx, centery, size);
      myCanvas.drawRadarLine(centerx, centery, size, scores, funsIsExist, window.settings.language);
      let url = myCanvas._canvas.toDataURL("image/jpeg");
      return url;
    },
    constituteEjs() {
      let sex = "";
      sex =
        this.printBaseInfo.sex === "M"
          ? this.$t("langcfg.txtMale")
          : this.printBaseInfo.sex === "F"
            ? this.$t("langcfg.txtFemale")
            : this.printBaseInfo.sex === "O"
              ? this.$t("langcfg.txtSexOther")
              : this.printBaseInfo.sex === "U"
                ? this.$t("langcfg.txtSexUnknown")
                : "";
      // 加载头页面
      // 打印的数据内容
      if (this.whichRecordSelected[0]) {
        this.carambolaImg.push(this.drawCarambola(this.recordOneData));
      }
      if (this.whichRecordSelected[1]) {
        this.carambolaImg.push(this.drawCarambola(this.recordTwoData));
      }
      this.renderEjs(
        fileSys.getCfgPath(`dryeyeReport/${this.selReportMode}/ReportHead.ejs`),
        {
          zoom: 1,
          lang: this.$i18n.messages[this.$i18n.locale].langcfg,
          title:
            this.mediviewSettingCfg.general.title === "Report"
              ? this.selReportMode === "MeibomianReport"
                ? this.$t("langcfg.txtMeibomianGlandReport")
                : this.$t("langcfg.txtPrintReport")
              : this.mediviewSettingCfg.general.title,
          age: this.printBaseInfo.age, // printBaseInfo 里面age字段为空
          sex: sex,
          id: this.printBaseInfo.id,
          name: this.printBaseInfo.name,
          checktype: this.printBaseInfo.checktype, // printBaseInfo里面没有checktype这个字段
          fontsize: this.printItemSize[this.mediviewSettingCfg.general.paper][2],
          hospitalname:
            this.mediviewSettingCfg.general.hospitalname &&
            this.mediviewSettingCfg.general.hospitalname.length > 0
              ? this.mediviewSettingCfg.general.hospitalname
              : "",
          hospitaltel:
            this.mediviewSettingCfg.general.hospitaltel &&
            this.mediviewSettingCfg.general.hospitaltel.length > 0
              ? "PrintHospitalTel" + ": " + this.mediviewSettingCfg.general.hospitaltel
              : "",
          hospitaladdr:
            this.mediviewSettingCfg.general.hospitaladdr &&
            this.mediviewSettingCfg.general.hospitaladdr.length > 0
              ? "PrintHospitalAddr" + ": " + this.mediviewSettingCfg.general.hospitaladdr
              : "",
          hospitallogo: fileSys.getCfgPath(this.mediviewSettingCfg.general.hospitallogo),
          CheckdateOne: this.printBaseInfo.CheckdateOne,
          CheckdateTwo: this.printBaseInfo.CheckdateTwo,
          recordOneEyetype:
            this.recordOneInfo && this.recordOneInfo.data ? this.recordOneInfo.data.type : "",
          recordTwoEyetype:
            this.recordTwoInfo && this.recordTwoInfo.data ? this.recordTwoInfo.data.type : ""
        },
        (str) => {
          let headhtml = str;
          this.renderEjs(
            fileSys.getCfgPath(`dryeyeReport/${this.selReportMode}/ReportTail.ejs`),
            {
              lang: this.$i18n.messages[this.$i18n.locale].langcfg,
              printdate: this.printBaseInfo.printdate,
              checkdoctor: window.printSettings.general.checkdoctor
            },
            (str) => {
              let tailhtml = str;
              this.renderEjs(
                fileSys.getCfgPath(`dryeyeReport/${this.selReportMode}/Carambola.ejs`),
                {
                  carambolaImg: this.carambolaImg,
                  whichRecordSelected: this.whichRecordSelected
                },
                (str) => {
                  let Carambola = str;
                  let needPrintPage = "";
                  adjustPageIsExist(
                    this.recordOneData,
                    this.recordTwoData,
                    sex,
                    (needhiddenFuns, needshowFuns) => {
                      this.constituteContentEjs(needhiddenFuns, needshowFuns, sex, (concent) => {
                        needPrintPage = concent;
                        let printHtml = "";
                        if (this.selReportMode === "oldReport") {
                          printHtml = `${headhtml}${Carambola}${needPrintPage}${tailhtml}`; // 需要打印的html
                        } else if (this.selReportMode === "newReport") {
                          printHtml = `${headhtml}${needPrintPage}${tailhtml}`; // 需要打印的html
                        }
                        if (this.debugPath.isdebug) {
                          fileSys.writeFileSync(
                            fileSys.getCfgPath(
                              `dryeyeReport/${this.selReportMode}/newReportTestFor520.html`
                            ),
                            printHtml
                          );
                          this.printHtmlUrl = fileSys.getCfgPath(
                            `dryeyeReport/${this.selReportMode}/newReportTestFor520.html`
                          );
                        } else {
                          fileSys.writeFileSync(
                            path.join(
                              fileSys.getCfgPath(),
                              `../cfg/dryeyeReport/${this.selReportMode}/newReportTestFor520.html`
                            ),
                            printHtml
                          );
                          this.printHtmlUrl = path.join(
                            fileSys.getCfgPath(
                              `../cfg/dryeyeReport/${this.selReportMode}/newReportTestFor520.html`
                            )
                          );
                        }
                      });
                    }
                  );
                }
              );
            }
          );
        }
      );
    },
    renderEjs(url, renderobj, callback) {
      try {
        ejs.renderFile(url, renderobj, (err, str) => {
          console.log(err);
          callback(str);
        });
      } catch (e) {
        let a = "";
        callback(a);
      }
    },
    constituteContentEjs(needhiddenFuns, needshowFuns, sex, callback) {
      let content = "";
      this.needPagination = false;
      let colorBarCanvas = new Drawcanvas(
        undefined,
        { height: 25, width: 290, size: true },
        "white"
      );
      for (let id in needshowFuns) {
        if (this.recordOneData[needshowFuns[id]].exist) {
          colorBarCanvas.drawPrintColorBar(
            0,
            10,
            290,
            50,
            this.recordOneData[needshowFuns[id]].score
          );
          this.recordOneData[needshowFuns[id]].colorBarUrl =
            colorBarCanvas._canvas.toDataURL("image/jpeg");
        }
        if (this.recordTwoData[needshowFuns[id]].exist) {
          colorBarCanvas.drawPrintColorBar(
            0,
            10,
            290,
            50,
            this.recordTwoData[needshowFuns[id]].score
          );
          this.recordTwoData[needshowFuns[id]].colorBarUrl =
            colorBarCanvas._canvas.toDataURL("image/jpeg");
        }
        // this.renderEjs(`${this.debugPath.config}dryeyeReport/${this.selReportMode}/${needshowFuns[id]}.ejs`, {
        this.renderEjs(
          fileSys.getCfgPath(`dryeyeReport/${this.selReportMode}/${needshowFuns[id]}.ejs`),
          {
            // lang: this.$i18n.messages[this.$i18n.locale].langcfg,
            lang: this.$i18n.messages[this.$i18n.locale].langcfg,
            whichRecordSelected: this.whichRecordSelected,
            language: window.settings.language,
            recordOneData: this.recordOneData,
            recordTwoData: this.recordTwoData
          },
          (str) => {
            content += str;
            if (needshowFuns.length > 4 && id === "3" && this.selReportMode === "oldReport") {
              this.needPagination = true;
              this.renderEjs(
                fileSys.getCfgPath(`dryeyeReport/${this.selReportMode}/SecondReportHead.ejs`),
                {
                  // lang: this.$i18n.messages[this.$i18n.locale].langcfg,
                  lang: this.$i18n.messages[this.$i18n.locale].langcfg,
                  title:
                    this.mediviewSettingCfg.general.title === "Report"
                      ? this.selReportMode === "MeibomianReport"
                        ? this.$t("langcfg.txtMeibomianGlandReport")
                        : this.$t("langcfg.txtPrintReport")
                      : this.mediviewSettingCfg.general.title,
                  hospitallogo: fileSys.getCfgPath(this.mediviewSettingCfg.general.hospitallogo),
                  // hospitallogo: (this.mediviewSettingCfg.general.hospitallogo && this.mediviewSettingCfg.general.hospitallogo.length > 0) ? this.mediviewSettingCfg.general.hospitallogo : fileSys.getCfgPath('/res/logo3.png'),
                  age: this.printBaseInfo.age,
                  sex: sex,
                  id: this.printBaseInfo.id,
                  name: this.printBaseInfo.name,
                  hospitalname:
                    this.mediviewSettingCfg.general.hospitalname &&
                    this.mediviewSettingCfg.general.hospitalname.length > 0
                      ? this.mediviewSettingCfg.general.hospitalname
                      : "",
                  hospitaltel:
                    this.mediviewSettingCfg.general.hospitaltel &&
                    this.mediviewSettingCfg.general.hospitaltel.length > 0
                      ? "PrintHospitalTel" + ": " + this.mediviewSettingCfg.general.hospitaltel
                      : "",
                  hospitaladdr:
                    this.mediviewSettingCfg.general.hospitaladdr &&
                    this.mediviewSettingCfg.general.hospitaladdr.length > 0
                      ? "PrintHospitalAddr" + ": " + this.mediviewSettingCfg.general.hospitaladdr
                      : "",
                  checktype: this.printBaseInfo.checktype,
                  CheckdateOne: this.printBaseInfo.CheckdateOne,
                  CheckdateTwo: this.printBaseInfo.CheckdateTwo,
                  recordOneEyetype:
                    this.recordOneInfo && this.recordOneInfo.data
                      ? this.recordOneInfo.data.type
                      : "",
                  recordTwoEyetype:
                    this.recordTwoInfo && this.recordTwoInfo.data
                      ? this.recordTwoInfo.data.type
                      : ""
                },
                (str) => {
                  content += str;
                  if (needshowFuns.length > 5 && id === "4" && this.selReportMode === "oldReport") {
                    this.needPagination = true;
                    content += this.renderEjs(
                      fileSys.getCfgPath(`dryeyeReport/${this.selReportMode}/SecondReportHead.ejs`),
                      {
                        // lang: this.$i18n.messages[this.$i18n.locale].langcfg,
                        lang: this.$i18n.messages[this.$i18n.locale].langcfg,
                        title:
                          this.mediviewSettingCfg.general.title === "Report"
                            ? this.selReportMode === "MeibomianReport"
                              ? this.$t("langcfg.txtMeibomianGlandReport")
                              : this.$t("langcfg.txtPrintReport")
                            : this.mediviewSettingCfg.general.title,
                        hospitallogo: fileSys.getCfgPath(
                          this.mediviewSettingCfg.general.hospitallogo
                        ),
                        // hospitallogo: (this.mediviewSettingCfg.general.hospitallogo && this.mediviewSettingCfg.general.hospitallogo.length > 0) ? this.mediviewSettingCfg.general.hospitallogo : fileSys.getCfgPath('/res/logo3.png'),
                        age: this.printBaseInfo.age,
                        sex: sex,
                        id: this.printBaseInfo.id,
                        name: this.printBaseInfo.name,
                        hospitalname:
                          this.mediviewSettingCfg.general.hospitalname &&
                          this.mediviewSettingCfg.general.hospitalname.length > 0
                            ? this.mediviewSettingCfg.general.hospitalname
                            : "",
                        hospitaltel:
                          this.mediviewSettingCfg.general.hospitaltel &&
                          this.mediviewSettingCfg.general.hospitaltel.length > 0
                            ? "PrintHospitalTel" +
                              ": " +
                              this.mediviewSettingCfg.general.hospitaltel
                            : "",
                        hospitaladdr:
                          this.mediviewSettingCfg.general.hospitaladdr &&
                          this.mediviewSettingCfg.general.hospitaladdr.length > 0
                            ? "PrintHospitalAddr" +
                              ": " +
                              this.mediviewSettingCfg.general.hospitaladdr
                            : "",
                        checktype: this.printBaseInfo.checktype,
                        CheckdateOne: this.printBaseInfo.CheckdateOne,
                        CheckdateTwo: this.printBaseInfo.CheckdateTwo,
                        recordOneEyetype:
                          this.recordOneInfo && this.recordOneInfo.data
                            ? this.recordOneInfo.data.type
                            : "",
                        recordTwoEyetype:
                          this.recordTwoInfo && this.recordTwoInfo.data
                            ? this.recordTwoInfo.data.type
                            : ""
                      },
                      (str) => {
                        content += str;
                      }
                    );
                  }
                }
              );
            }
          }
        );
      }
      callback(content);
    },
    ready() {
      console.time("reporttime");
      if (this.recordOneInfo && !this.recordTwoInfo) {
        this.whichRecordSelected = [true, false];
      } else if (this.recordTwoInfo && !this.recordOneInfo) {
        this.whichRecordSelected = [false, true];
      } else if (this.recordOneInfo && this.recordTwoInfo) {
        this.whichRecordSelected = [true, true];
      }
      this.mediviewSettingCfg = window.printSettings;
      let sex = "";
      this.printBaseInfo = {
        sex: sex,
        imgs: [],
        age: this.currentPatient.birthday,
        name: this.currentPatient.firstname,
        id: this.currentPatient.pid,
        printdate: formatDate(getSystemTime(), this.dateFormat, true),
        checkdoctor: window.printSettings.general.checkdoctor,
        checkresult: "",
        CheckdateOne: this.recordOneInfo && this.recordOneInfo.data.date,
        CheckdateTwo: this.recordTwoInfo && this.recordTwoInfo.data.date
      };
      this.printBaseInfo.sex =
        this.currentPatient.sex === "M"
          ? this.$t("langcfg.txtMale")
          : this.currentPatient.sex === "F"
            ? this.$t("langcfg.txtFemale")
            : this.currentPatient.sex === "O"
              ? this.$t("langcfg.txtSexOther")
              : this.currentPatient.sex === "U"
                ? this.$t("langcfg.txtSexUnknown")
                : "";
    }
  },
  watch: {
    startShowReport(newVal) {
      let _this = this;
      if (newVal) {
        if (this.recordOneInfo || this.recordTwoInfo) {
          _this.webview = true;
          _this.ready();
          _this.start();
          _this.constituteEjs();
        } else if (
          this.recordOneInfo === "" ||
          this.recordTwoInfo === "" ||
          this.recordOneInfo === undefined ||
          this.recordTwoInfo === undefined
        ) {
          _this.webview = false;
          _this.$emit("exportFinished", true);
        }
      }
    }
    // recordOneInfo (newVal) {
    //   if ((newVal && !this.recordTwoInfo) || (newVal && this.recordTwoInfo)) {
    //     if (newVal) {
    //       this.webview = true
    //     }
    //     this.ready()
    //     this.start()
    //     this.constituteEjs()
    //   }
    // },
    // recordTwoInfo (newVal) {
    //   if (newVal && !this.recordOneInfo) {
    //     this.webview = true
    //     this.ready()
    //     this.start()
    //     this.constituteEjs()
    //   }
    // }
  },
  computed: {
    ...mapGetters(["dateFormat"])
  }
  // ,
  // beforeDestroy () {
  //   this.webview = false
  //   this.$refs.wviewPrint.choicesSelect()
  // }
};
</script>

<style scoped>
.report {
  height: 80%;
  background-color: #fff;
  position: absolute;
  top: 0;
  z-index: 10;
  right: 0;
  bottom: 0;
  margin: auto;
  color: #1b1b1b;
}

.print-div {
  background-color: #4b505e;
  white-space: nowrap;
  overflow-x: scroll;
  overflow-y: auto;
  resize: none;
  width: 100%;
  height: 800px;
}
</style>



// WEBPACK FOOTER //
// src/mainInterface/components/exportUserList/report.vue